export class RoleEditModel{
    name:string;
}